import { useCallback, useState } from "react";
import {
  getAccountExpansionStorageKey,
  getStoredAccountExpansion,
  storeAccountExpansion,
} from "./utils";

export const usePersistedExpansion = (
  companyId: number,
  accountKey: number | "new-account"
) => {
  const storageKey = getAccountExpansionStorageKey(companyId, accountKey);
  const [expanded, setExpanded] = useState(() =>
    getStoredAccountExpansion(storageKey)
  );
  const toggleExpanded = useCallback(() => {
    setExpanded((current) => {
      const next = !current;
      storeAccountExpansion(storageKey, next);
      return next;
    });
  }, [storageKey]);
  return { expanded, toggleExpanded };
};
